import React, { useState, useRef } from 'react';
import API_CALLS from 'API_CALLS/index';
import FormFieldsNew from 'API_CALLS/USERS/FORM_FIELDS_NEW';
import {FINAL_MOD_NEW} from 'API_CALLS/USERS/index';

import FormBuilder from 'global/components/FormBuilder/index';


class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curObj: {
        role: "USER",
        createRequestTreatmentPlanTask: true,
        sendWelcomeEmail: false
      }
    };    
  }

  APINewUser = async () => {  
    var {curObj} = this.state;
    var curObjClean = API_CALLS.USERS.FINAL_MOD_NEW(curObj);
    await window.Client.mutate({
      mutation: API_CALLS.USERS.MUTATIONS.create(),
      variables: {
        ...curObjClean
      }
    })
    .catch(failed=>{
      console.log(`Failed to create New User`,"\n\n",failed,"\n\n");
      window.GlobalUtil.DialogStack.closeTop()
    });
    return true;
  }

  render(){
    var {curObj, curStatus} = this.state;          
    return(
      <button 
        className="button button1 bigIconButtons" 
        onClick={(e)=>{
        e.preventDefault();
        window.GlobalUtil.triggerEvent("SlideInRightEvent", {
          TITLE: "New User",
          closeButtonText: "Cancel",
          saveButtonText: "Create",
          customClass: "frontEndSlideInRight shortSlideInRight newOrderDialog",
          width: "1200px",
          onClose: ()=>{
            // this.setState({activeNote: {
            //   note: '',
            //   createAt: new Date(),
            //   updateAt: new Date(),
            //   status: 'ACTIVE'
            // }}) 
          },
          onSave: async ()=>{
            await this.APINewUser();
            return;
          },
          children: (propsChildren)=>{                                      
            return(
              <div className="dialogCustomZone">
                <FormBuilder
                  ref={e => this.formRef = e}
                  initialValues={curObj}
                  listOfFields={FormFieldsNew()}
                  onSubmit={()=>{}}
                  onChange={(newObj)=>{
                    this.setState({curObj: newObj})
                  }}
                  onValidate={propsChildren.onChangeValid}
                />
              </div>
            )
          }
        });
      }}><span>New User</span>&nbsp;&nbsp;<i className="fas fa-user" /></button>
    )
  }
}


export default Index;
      
